export default "__VITE_ASSET__syJ$Myg7__"